// extracted by mini-css-extract-plugin
export default {"root":"IconVisitCalendar_root__R7GPU"};